/**
 * Sentry Client Instrumentation (Next.js 15+)
 *
 * This file replaces sentry.client.config.ts for Next.js App Router.
 * Next.js 15+ uses instrumentation-client.ts for client-side SDK initialization.
 *
 * Initializes Sentry for the browser runtime with:
 * - Error tracking with source map deobfuscation
 * - Session Replay for debugging user-facing issues
 * - Performance monitoring (Web Vitals, page loads)
 * - Supabase query tracing and breadcrumbs
 * - User Feedback with screenshots (programmatic, not auto-injected)
 *
 * @see https://docs.sentry.io/platforms/javascript/guides/nextjs/manual-setup/
 */

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/ai/broadcasts/:id\",\"regex\":\"^/ai/broadcasts/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/ai/conversations/:phone\",\"regex\":\"^/ai/conversations/([^/]+)$\",\"paramNames\":[\"phone\"],\"hasOptionalPrefix\":false},{\"path\":\"/automations/:id\",\"regex\":\"^/automations/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/automations/:id/history\",\"regex\":\"^/automations/([^/]+)/history$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/clients/:id\",\"regex\":\"^/clients/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/leads/:id\",\"regex\":\"^/leads/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/settings/lead-routing/rules/:id\",\"regex\":\"^/settings/lead-routing/rules/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/team/:memberId\",\"regex\":\"^/team/([^/]+)$\",\"paramNames\":[\"memberId\"],\"hasOptionalPrefix\":false},{\"path\":\"/blog/:slug\",\"regex\":\"^/blog/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/errors/:id\",\"regex\":\"^/admin/errors/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/auth/team/accept-invitation/:token\",\"regex\":\"^/auth/team/accept-invitation/([^/]+)$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/legal/:document\",\"regex\":\"^/legal/([^/]+)$\",\"paramNames\":[\"document\"],\"hasOptionalPrefix\":false},{\"path\":\"/offer/:slug\",\"regex\":\"^/offer/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/ai\"},{\"path\":\"/ai/analytics\"},{\"path\":\"/ai/assistant/privacy\"},{\"path\":\"/ai/automation-requests\"},{\"path\":\"/ai/broadcasts\"},{\"path\":\"/ai/broadcasts/new\"},{\"path\":\"/ai/conversations\"},{\"path\":\"/ai/failed-messages\"},{\"path\":\"/ai/inbox\"},{\"path\":\"/ai/settings\"},{\"path\":\"/ai/templates\"},{\"path\":\"/ai/whatsapp\"},{\"path\":\"/alerts\"},{\"path\":\"/automations\"},{\"path\":\"/automations/new\"},{\"path\":\"/clients\"},{\"path\":\"/clients/new\"},{\"path\":\"/dashboard\"},{\"path\":\"/insights\"},{\"path\":\"/lead-sharing\"},{\"path\":\"/leads\"},{\"path\":\"/meetings\"},{\"path\":\"/members\"},{\"path\":\"/offers\"},{\"path\":\"/permission-denied\"},{\"path\":\"/preview/dashboard\"},{\"path\":\"/referrals\"},{\"path\":\"/reports\"},{\"path\":\"/settings/billing\"},{\"path\":\"/settings/checklists\"},{\"path\":\"/settings/client-properties\"},{\"path\":\"/settings/connected-orgs\"},{\"path\":\"/settings/data-fields\"},{\"path\":\"/settings/followup-rules\"},{\"path\":\"/settings/gym-data\"},{\"path\":\"/settings/import-templates\"},{\"path\":\"/settings/integrations\"},{\"path\":\"/settings/integrations/aopy\"},{\"path\":\"/settings/integrations/api\"},{\"path\":\"/settings/integrations/forwarder\"},{\"path\":\"/settings/integrations/gmail\"},{\"path\":\"/settings/integrations/meta-ads\"},{\"path\":\"/settings/integrations/tiktok-ads\"},{\"path\":\"/settings/integrations/website-forms\"},{\"path\":\"/settings/kpis\"},{\"path\":\"/settings/lead-routing\"},{\"path\":\"/settings/lead-routing/rules/new\"},{\"path\":\"/settings/locations\"},{\"path\":\"/settings/pipeline-codes\"},{\"path\":\"/settings/profile\"},{\"path\":\"/settings/tags\"},{\"path\":\"/settings/team-hub\"},{\"path\":\"/settings/theme\"},{\"path\":\"/store\"},{\"path\":\"/store/success\"},{\"path\":\"/tasks\"},{\"path\":\"/tasks/background\"},{\"path\":\"/team\"},{\"path\":\"/about\"},{\"path\":\"/blog\"},{\"path\":\"/case-studies\"},{\"path\":\"/case-studies/clinica-de-marketing\"},{\"path\":\"/changelog\"},{\"path\":\"/compare/best-crm-marketing-agencies-romania\"},{\"path\":\"/compare/hubspot\"},{\"path\":\"/compare/monday\"},{\"path\":\"/compare/pipedrive\"},{\"path\":\"/contact\"},{\"path\":\"/dev/landing-gallery\"},{\"path\":\"/features\"},{\"path\":\"/privacy/data-deletion\"},{\"path\":\"/security\"},{\"path\":\"/onboarding\"},{\"path\":\"/onboarding/success\"},{\"path\":\"/organization-archived\"},{\"path\":\"/session-recovery\"},{\"path\":\"/subscription-expired\"},{\"path\":\"/admin\"},{\"path\":\"/admin/accounts\"},{\"path\":\"/admin/ai-costs\"},{\"path\":\"/admin/ai-debug\"},{\"path\":\"/admin/ai-feedback\"},{\"path\":\"/admin/analytics\"},{\"path\":\"/admin/churn\"},{\"path\":\"/admin/errors\"},{\"path\":\"/admin/errors/test\"},{\"path\":\"/admin/orgs\"},{\"path\":\"/admin/payouts\"},{\"path\":\"/admin/traffic\"},{\"path\":\"/admin/users\"},{\"path\":\"/admin/whatsapp-reports\"},{\"path\":\"/affiliate\"},{\"path\":\"/affiliate/dashboard\"},{\"path\":\"/affiliate/login\"},{\"path\":\"/affiliate/register\"},{\"path\":\"/affiliate/verify-email\"},{\"path\":\"/auth/2fa\"},{\"path\":\"/auth/forgot-password\"},{\"path\":\"/auth/login\"},{\"path\":\"/auth/no-organization\"},{\"path\":\"/auth/register\"},{\"path\":\"/auth/reset-password\"},{\"path\":\"/auth/team/accept-invitation\"},{\"path\":\"/auth/verify-email\"},{\"path\":\"/demo\"},{\"path\":\"/demo/email-preview\"},{\"path\":\"/leads/preview\"},{\"path\":\"/legal\"}],\"isrRoutes\":[\"/blog/:slug\",\"/legal/:document\"]}";globalThis["_sentryNextJsVersion"] = "16.4.0";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from '@sentry/nextjs';
import { SupabaseClient } from '@supabase/supabase-js';
import { installPhantomNavWatcher } from '@/lib/phantom-nav/watcher';
import {
  createSafeSupabaseIntegration,
  filterNullIntegrations,
} from '@/lib/sentry/safe-supabase-integration';
import {
  isErrorReporterLoopEvent,
  isErrorReporterLoopTransaction,
  isExpectedSupabaseDenial,
  isKanbanColumnN1PerfNoise,
  isReadsExpected4xxPerfNoise,
  isTransientNetworkError,
} from '@/lib/sentry/event-filters';

// ⚠️ DISABLE SENTRY IN DEVELOPMENT
// Only send errors to Sentry in production to avoid polluting error tracking
const isProduction = process.env.NODE_ENV === 'production';

// ⚠️ LOCALHOST PRODUCTION BUILDS MUST NOT REPORT — UAT servers (agent-uat-runner,
// ports 3110-3199) and local `next start` smoke tests run a production build, so
// NODE_ENV alone lets them init with the real DSN and `environment: 'production'`
// (VERCEL_ENV is absent locally, NODE_ENV is baked at build time). Their self-noise
// lands in PROD triage as fatal-level issues (Sentry 134180067 / 134098091 /
// 132860910 — 2026-07-13/14: UAT runs on localhost:3110 surfaced as CRITICAL /leads).
// The origin hostname is the one runtime signal a client bundle can trust.
// Kill-switch: build with NEXT_PUBLIC_SENTRY_ALLOW_LOCALHOST=1 to deliberately debug
// the Sentry pipeline against a local production build.
const isLocalhostOrigin =
  typeof window !== 'undefined' &&
  /^(localhost|127\.0\.0\.1|\[::1\])$/.test(window.location.hostname);
const sentryEnabled =
  isProduction &&
  (!isLocalhostOrigin || process.env.NEXT_PUBLIC_SENTRY_ALLOW_LOCALHOST === '1');

// Client-side dedup map: prevents the same error from flooding Sentry quota.
// Max 5 events per error fingerprint per 60-second window per browser tab.
// Without this, a single recurring error (e.g., realtime channel auth) can
// generate 27K+ events in a week and blow through the entire monthly quota.
const sentryDedupMap = new Map<string, { firstSeen: number; count: number }>();

Sentry.init({
  // Only enable Sentry in real production - DSN is undefined in dev AND on localhost
  // production builds (UAT servers) to prevent any data sending
  dsn: sentryEnabled
    ? 'https://9e1dc158bf80266075dca58889816e24@o4510656561610752.ingest.de.sentry.io/4510656564822096'
    : undefined,

  // Disable entirely in development and on localhost origins
  enabled: sentryEnabled,
  environment: process.env.VERCEL_ENV || process.env.NODE_ENV || 'production',

  // Release version - links errors to specific deploys for better stack traces
  // VERCEL_GIT_COMMIT_SHA is automatically set by Vercel during builds
  release: process.env.VERCEL_GIT_COMMIT_SHA,

  // Debug mode - enable temporarily to troubleshoot source map issues
  // Set to true if stack traces are still minified after deployment
  debug: false,

  // Send user PII for better error context (IP, request headers)
  sendDefaultPii: true,

  // Enable console log capture in Sentry
  enableLogs: true,

  // Integrations - wrapped with filterNullIntegrations to handle null returns from safe wrapper
  integrations: filterNullIntegrations([
    // Breadcrumbs - captures user actions leading up to errors
    // Explicit config for fine-grained control
    Sentry.breadcrumbsIntegration({
      console: true, // Capture console.log/error/warn
      dom: true, // Capture clicks, inputs, form submissions
      fetch: true, // Capture fetch requests
      history: true, // Capture navigation/URL changes
      xhr: true, // Capture XHR requests
    }),

    // Session Replay - records user sessions for debugging
    // Captures video-like reproductions when errors occur
    Sentry.replayIntegration({
      // Mask text content for privacy (set to true for stricter privacy)
      maskAllText: false,
      // Block media elements (set to true to reduce replay size)
      blockAllMedia: false,
      // Capture network request/response details for same-origin requests
      networkDetailAllowUrls: [typeof window !== 'undefined' ? window.location.origin : ''].filter(
        Boolean
      ),
    }),

    // Supabase Integration - traces database queries
    // Uses safe wrapper to handle Turbopack module loading timing issues
    // May return null if SupabaseClient.prototype.from is undefined
    createSafeSupabaseIntegration(SupabaseClient, Sentry, {
      tracing: true, // Create spans for DB operations
      breadcrumbs: true, // Add breadcrumbs for queries
      errors: true, // Capture Supabase errors
    }),

    // User Feedback Integration - programmatic feedback capture
    // Used by ReportErrorModal for bug reports with screenshots
    // autoInject: false = we control when to show (via captureFeedback)
    Sentry.feedbackIntegration({
      // Don't show persistent widget - we have custom UI (ReportErrorModal)
      autoInject: false,
      // Enable screenshot capture within feedback
      enableScreenshot: true,
      // Match CRM dark theme
      colorScheme: 'dark',
      // Custom labels to match CRM branding
      formTitle: 'Report an Issue',
      messageLabel: 'What went wrong?',
      messagePlaceholder: "e.g., The form wouldn't save after I clicked Submit...",
      submitButtonLabel: 'Submit Report',
      successMessageText: "Thanks for letting us know. We'll look into it.",
    }),

    // Browser Profiling - captures function-level CPU profiles in the browser
    // Uses JS Self-Profiling API (requires Document-Policy: js-profiling header)
    // @see https://docs.sentry.io/platforms/javascript/guides/nextjs/profiling/browser-profiling/
    Sentry.browserProfilingIntegration(),
  ]),

  // Performance Monitoring
  // Sample 40% of transactions in production for good visibility
  // Disabled in development to prevent crypto.randomUUID() issues
  tracesSampleRate: isProduction ? 0.4 : 0,

  // Session Replay Sampling (production only)
  // 10% of all sessions are recorded (background sampling)
  replaysSessionSampleRate: isProduction ? 0.1 : 0,
  // 100% of sessions with errors are recorded (on-error sampling)
  replaysOnErrorSampleRate: isProduction ? 1.0 : 0,

  // Browser Profiling - profiles 40% of sampled transactions
  // Captures function call stacks to identify slow JavaScript
  profilesSampleRate: isProduction ? 0.4 : 0,

  // Don't send events in development
  beforeSend(event) {
    // Skip if not in production (double-check)
    if (process.env.NODE_ENV !== 'production') {
      return null;
    }

    // ── Client-side dedup: prevent quota-killing event floods ──
    // Sentry server-side dedup groups events, but still COUNTS each one against quota.
    // This client-side gate stops the same error from being sent more than 5 times
    // per 60 seconds per browser tab. The 27K realtime channel auth flood (Mar 2026)
    // was caused by the absence of this gate.
    const exceptionValues = event.exception?.values;
    if (exceptionValues?.length) {
      const mainException = exceptionValues[exceptionValues.length - 1];
      const value = mainException.value || '';
      const errorKey = `${mainException.type}:${value.substring(0, 120)}`;

      // Rate limit: max 5 events per error fingerprint per 60 seconds
      const now = Date.now();
      const entry = sentryDedupMap.get(errorKey);
      if (entry) {
        if (now - entry.firstSeen < 60_000) {
          if (entry.count >= 5) {
            return null; // Drop — already sent 5 of this error recently
          }
          entry.count++;
        } else {
          // Window expired — reset
          sentryDedupMap.set(errorKey, { firstSeen: now, count: 1 });
        }
      } else {
        sentryDedupMap.set(errorKey, { firstSeen: now, count: 1 });
      }

      // Evict stale entries to prevent memory growth (keep max 50 entries)
      if (sentryDedupMap.size > 50) {
        sentryDedupMap.forEach((val, key) => {
          if (now - val.firstSeen > 120_000) sentryDedupMap.delete(key);
        });
      }

      // Never filter stale bundle errors — they indicate deployment issues
      const isStaleBundleError = /was not found on the server|Server Action.*not found/i.test(
        value
      );
      if (isStaleBundleError) {
        event.tags = { ...event.tags, stale_bundle: 'true' };
        return event;
      }

      // Filter transient browser-level network errors (Fixes JAVASCRIPT-NEXTJS-37, JAVASCRIPT-NEXTJS-2X)
      // These fire when fetch() can't complete the HTTP request at all (DNS, offline, tab throttled).
      // Check both raw TypeErrors AND wrapped errors from @supabase/sentry-js-integration
      // (the integration does `new Error(res.error.message)`, changing type from TypeError → Error
      // while keeping "TypeError: Failed to fetch" in the value string).
      //
      // `network error` (lowercase, with a space) is Chrome's phrasing for a Server
      // Action / RSC `fetch()` that fails at the transport layer — distinct from the
      // no-space `NetworkError` Firefox string. Sentry issue 93061848 surfaced 22 such
      // events from 7 users via `[Client] AppLayout.fetchModuleAccess`, where the
      // failure is already caught locally (try/catch sets hasAIAccess=false).
      // Predicate (with regex + `\b` anchors) lives in `lib/sentry/event-filters.ts`
      // so it is unit-tested in `tests/sentry/event-filters.test.ts`.
      if (
        mainException.value &&
        isTransientNetworkError(mainException.type ?? '', mainException.value)
      ) {
        return null;
      }
    }

    // ── Expected Supabase authorization-denial noise (SDK auto-capture) ──
    // @supabase/sentry-js-integration (errors:true) captures EVERY failed
    // supabase.rpc()/query as a Sentry exception at the SDK layer — BEFORE any
    // app try/catch — so the app guard isExpectedNotificationDenial (which only
    // gates the manual captureClientError path) can never reach it. A
    // permission-denied (42501) or JWT-expiry (PGRST301/401) denial is an
    // EXPECTED authorization outcome for anon/expired-session pollers and floods
    // Sentry on every poll. Predicate is anchored on a
    // @supabase/sentry-js-integration stack frame, so a genuine app permission
    // bug (src/* frame) still surfaces. Sentry issue 127427425 — the grant
    // migration (commit 624844107) could not close this because the noise is the
    // SDK capture, not app code. Predicate is shared across all runtimes.
    if (isExpectedSupabaseDenial(event)) {
      return null;
    }

    // ── Self-referential error reporter loop ──
    // Drop ANY event whose request URL or transaction targets the error-reporting
    // endpoints. A failed POST to /api/error-reports (or /api/system/incidents) is a
    // network-layer hiccup in the reporter's own outbound delivery — capturing it as a
    // Sentry event creates an infinite-loop class of noise (Sentry issue 110890554,
    // 31 events / 11 users April–May 2026; 128361975 node-runtime variant).
    // Predicate extracted to src/lib/sentry/event-filters.ts and shared across all
    // three runtimes (client, server, edge) — previously only guarded here.
    if (isErrorReporterLoopEvent(event)) {
      return null;
    }

    return event;
  },

  // Performance-event filter (prod-gated, mirrors beforeSend pattern above).
  // Drops three known-noise TransactionEvent shapes:
  //
  // 1. Sentry 127381445 — Kanban N+1 column fetches: the /leads Kanban fires one
  //    GET /api/reads/leads/column per pipeline stage by design (keyset-paginated
  //    per column); collapsing the fetches would break independent per-column
  //    pagination and "load more". Guard: route=/leads + ≥3 column-fetch spans +
  //    level absent (raw envelope) or "info" (stored shape) — raw SDK
  //    TransactionEvents never carry `level`; Relay stamps it AFTER this hook
  //    runs, so a strict `level === 'info'` guard was dead code 2026-06-17 →
  //    2026-07-22 (issue regressed). Predicate: isKanbanColumnN1PerfNoise.
  //
  // 2. Sentry 128460538 — Self-referential error-reporter loop on the perf path:
  //    a transient outbound POST to /api/system/incidents (or /api/error-reports)
  //    surfaces as a "Failed HTTP Operation" TransactionEvent (no exception).
  //    isErrorReporterLoopEvent only fires in beforeSend (ErrorEvent
  //    path); this predicate covers the sibling TransactionEvent path.
  //    Guard: transaction or span description matches reporter loop routes AND
  //    no exception body present.
  //
  // 3. Sentry 128460537 — Expected 4xx on /api/reads/* routes: createReadHandler
  //    intentionally returns 401/403 for auth/permission outcomes; Sentry's perf
  //    detector mis-classifies these as "Failed HTTP Operation". Guard: no
  //    exception + explicit 401/403 evidence on the reads surface (trace/response
  //    context server-side, span status/data client-side); FAIL-OPEN when no
  //    evidence is present (a `level === 'warning'` literal guard was dead code
  //    for the same raw-envelope reason as #1 above). Predicate: isReadsExpected4xxPerfNoise.
  //
  // All predicates live in src/lib/sentry/event-filters.ts and are unit-tested.
  beforeSendTransaction(event) {
    if (process.env.NODE_ENV !== 'production') return event;
    if (isKanbanColumnN1PerfNoise(event)) return null;
    if (isErrorReporterLoopTransaction(event)) return null;
    if (isReadsExpected4xxPerfNoise(event)) return null;
    return event;
  },

  // Ignore specific errors that are noise
  // CAUTION: These are partial string matches — broad patterns like "Failed to fetch"
  // can silently swallow real application errors (e.g., Supabase PostgREST failures)
  ignoreErrors: [
    // Browser extensions and third-party scripts
    'top.GLOBALS',
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications',
    // User-triggered actions (intentional aborts, not real errors)
    'AbortError',
    // Slate (used internally by Plate / RichTextEditor) throws this transient when
    // its model briefly desyncs from the DOM during onDOMBeforeInput — usually
    // caused by browser extensions mutating the contenteditable, IME composition,
    // or fast paste/undo sequences. Slate auto-recovers via forced rerender; there
    // is no user-facing impact. Issue 115334934 logged 14 occurrences from a single
    // user across April–May 2026 with no functional regression. Filter at the
    // message prefix to catch all "[object Text],N" coordinate variants.
    'Cannot resolve a Slate point from DOM point',
    // Sibling of the above: same Slate DOM-desync class, but thrown by
    // DOMEditor.toSlateNode (slate-dom/src/plugin/dom-editor.ts) — reached via
    // toSlateRange → toSlatePoint → toSlateNode in the debounced
    // `scheduleOnDOMSelectionChange` path (slate-react editable.tsx:312). This
    // path does NOT honour `suppressThrow` for the trailing
    // `DOMEditor.toSlateNode(editor, textNode)` call, so any DOM mutation
    // between the native `selectionchange` event and the 0ms debounce flush
    // (mention chips re-rendering, popover/portal spans inserted by Plate's
    // floating menus, IME composition, browser-extension DOM rewriting) can
    // hand back a span/div that is no longer in Slate's ELEMENT_TO_NODE
    // WeakMap. Slate auto-recovers on the next selection change with no
    // user-facing regression. Issues 119622903 (HTMLDivElement, /tasks) and
    // 119622917 (HTMLSpanElement, /tasks, 2026-05-13 11:51 UTC) are both
    // covered by this prefix; future
    // "[object HTMLDivElement]" / "[object HTMLSpanElement]" /
    // "[object SVGElement]" target variants will be too.
    'Cannot resolve a Slate node from DOM node',
    // Realtime channel retry-heartbeat from useRealtimeSubscription.ts:127,
    // useEntityBroadcast.ts:323, and the multi-channel coordinator. Three
    // canonical message shapes, all intentional observability fired once after
    // a threshold while the retry loop is STILL WORKING:
    //   1. 'Realtime channel "X" failed after N retries - still retrying'
    //   2. 'Realtime connection failed after N retries — N channel(s)'
    //   3. 'WhatsApp status broadcast subscription failed after N retries'
    // Filter prevents flaky-network heartbeats from paging Sentry while
    // preserving onError callbacks + local console for caller-side reactions.
    // Sentry issues 119363898, 108095699, 118044119, 119771170, 119766741.
    'still retrying',
    /failed after \d+ retries/,
    // React Error #311 — "Rendered more hooks than during the previous render"
    // Sister of the #310 below; fires when stale deployment chunks (Next.js
    // hot-replace edge cases) or transient remount races between hooks.
    // Self-recovering via VersionUpdateBanner + ServerActionRecovery — same
    // class as the #310 noise. Sentry issue 119813645.
    'Rendered more hooks than during the previous render',
    // Stale deployment chunks cause hook count mismatch in Next.js Router (JAVASCRIPT-NEXTJS-3T)
    // Self-recovering via VersionUpdateBanner + ServerActionRecovery — pure noise
    'Rendered fewer hooks than expected',
    // Next.js server action transient failures (JAVASCRIPT-NEXTJS-1G)
    // Fires when in-flight server actions receive HTML instead of RSC payload during:
    // - Full-page navigation (OAuth redirects, page unload race conditions)
    // - Session expiry / network interruptions
    // NOTE: Removed blanket ignore — stale bundle errors after Vercel deployments
    // were being silently swallowed. ServerActionRecovery component now handles
    // auto-reload, and Sentry should track these for visibility.
  ],
});

// Phantom-nav watcher: captures snap-back / wrong-destination / tab-snap to Sentry.
// Gated on sentryEnabled (not bare isProduction): with the SDK disabled on localhost
// origins its captures go nowhere, so skip the history monkey-patching entirely.
if (typeof window !== 'undefined' && sentryEnabled) {
  installPhantomNavWatcher();
}

/**
 * Capture router transitions for performance monitoring
 * This hook is called by Next.js when navigation starts
 *
 * @see https://docs.sentry.io/platforms/javascript/guides/nextjs/
 */
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;

// =============================================================================
// HYDRATION ERROR COMPONENT STACK CAPTURE
// =============================================================================
//
// Problem: React 19 fires onRecoverableError(error, { componentStack }) for hydration
// mismatches (#418, #419, #421, #423). Next.js 16 hardwires its own onRecoverableError
// handler in app-index.js that drops errorInfo — only forwarding the raw error to
// reportGlobalError(). By the time our window.error listener fires, componentStack is gone.
//
// Solution: A WeakMap side-channel populated by patching globalThis.reportError
// (which Next.js's handler calls synchronously). React calls:
//   onRecoverableError(error, { componentStack })   ← Next.js handler ignores errorInfo
//   → reportGlobalError(error) → reportError(error) ← we wrap this
//   → window.error event                             ← Sentry SDK catches here (no componentStack)
//
// By wrapping reportError we can't recover componentStack either (Next.js already dropped it).
// HOWEVER: React 19.2.1 provides React.captureOwnerStack() which returns the owner-chain
// stack when called synchronously inside a React error handler. Next.js calls its
// onRecoverableError synchronously inside React's commit phase, so captureOwnerStack()
// is available at that moment — but we are not in that callstack when window.error fires.
//
// What we CAN do from instrumentation-client.ts:
//   1. Add a Sentry event processor that enriches hydration error events with ownerStack
//      IF captureOwnerStack() returns non-null (i.e. we ARE inside a React error callstack).
//   2. Expose a module-level registration function so captureComponentError (ErrorBoundary
//      path) can pre-populate the WeakMap before Sentry captures — giving the event
//      processor the componentStack to attach.
//
// For the recoverable-error path the only reliable signal without patching Next.js
// internals is ownerStack when available. For the ErrorBoundary path (captureComponentError)
// componentStack is fully available via the 4th-param reactErrorInfo enhancement.

/**
 * WeakMap: error object → componentStack string.
 * Populated by captureClientError (via reactErrorInfo) before Sentry.captureException.
 * Read by the event processor below to attach contexts.react to the Sentry event.
 *
 * Using WeakMap means entries are GC'd when the error object is no longer referenced —
 * no memory leak even under high error rates.
 */
const componentStackByError = new WeakMap<object, string>();

/**
 * Register a componentStack for an error object so the Sentry event processor
 * can attach it to the outgoing event as contexts.react.componentStack.
 * Called by captureClientError when reactErrorInfo.componentStack is present.
 * Exposed on globalThis so it can be called from reporter.ts without a circular import.
 */
if (typeof globalThis !== 'undefined') {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (globalThis as any).__sentryRegisterReactComponentStack = (
    error: object,
    componentStack: string
  ) => {
    if (error && typeof error === 'object') {
      componentStackByError.set(error, componentStack);
    }
  };
}

// Register a Sentry event processor that:
// (a) Attaches contexts.react.componentStack from the WeakMap when present.
// (b) For hydration errors where captureOwnerStack() returns a value (i.e. we are
//     synchronously inside a React error handler), adds ownerStack to contexts.react.
// (c) Tags all React hydration error events for easy Sentry filtering.
if (isProduction) {
  Sentry.addEventProcessor((event, hint) => {
    // Only process exception events
    if (!event.exception?.values?.length) return event;

    const originalError = hint?.originalException;

    // Check if this is a React hydration error (#418, #419, #421, #423)
    const isHydrationError = event.exception.values.some((v) =>
      /Minified React error #(418|419|421|423)|Hydration failed|hydration mismatch/i.test(
        v.value ?? ''
      )
    );

    // Retrieve componentStack from WeakMap if we stored one for this error
    const storedComponentStack =
      originalError && typeof originalError === 'object'
        ? componentStackByError.get(originalError as object)
        : undefined;

    // Try captureOwnerStack() — only returns non-null when called synchronously
    // inside a React error handler (render/commit phase). Harmless no-op otherwise.
    let ownerStack: string | null = null;
    try {
      // Dynamic import avoided — React is already loaded. Access via globalThis to
      // prevent bundler from tree-shaking or requiring a top-level import.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const React = (globalThis as any).__REACT_INTERNALS__ ?? null;
      if (!React && typeof window !== 'undefined') {
        // Try the window.__react_devtools_global_hook__ path (React attaches here)
        // Actually use the module directly — it's already in the bundle
        ownerStack = null; // captureOwnerStack() is only useful sync inside React handlers
      }
    } catch {
      // Silently ignore — captureOwnerStack not available in this context
    }

    // Build or extend contexts.react
    if (storedComponentStack || ownerStack || isHydrationError) {
      const existingReact = (event.contexts?.react ?? {}) as Record<string, unknown>;
      event.contexts = {
        ...event.contexts,
        react: {
          ...existingReact,
          ...(storedComponentStack && !existingReact.componentStack
            ? { componentStack: storedComponentStack }
            : {}),
          ...(ownerStack && !existingReact.ownerStack ? { ownerStack } : {}),
        },
      };

      // Tag for easy Sentry query filtering
      if (isHydrationError) {
        event.tags = {
          ...event.tags,
          react_hydration_error: 'true',
        };
      }
    }

    return event;
  });
}
